export default __webpack_public_path__ + "static/media/Loader.3e9fc77f.gif";